import { getStage } from "./context";

export const showCommsPreferences = getStage() !== "prod";

export const showContractAddendum = getStage() !== "prod";

export const showPBBv2AcceptUpdates = getStage() !== "prod";
